/**
 * Checks if an environment variable value is truthy.
 * Pass the actual env value (e.g., process.env.REACT_APP_MY_VAR) not the variable name.
 * This is required for Rsbuild to statically replace env vars at build time.
 */
export const isTruthyStringEnvVariable = (envValue, defaultValue) => {
  return envValue === undefined ? defaultValue : envValue.toLowerCase() !== 'false';
};

/**
 * Checks if an environment variable value is strictly 'true'.
 * Pass the actual env value (e.g., process.env.REACT_APP_MY_VAR) not the variable name.
 * This is required for Rsbuild to statically replace env vars at build time.
 */
export const isStrictBool = (envValue, defaultValue) => {
  return envValue?.toLowerCase() === 'true' ? true : defaultValue;
};
